import { render, staticRenderFns } from "./EditSubAsset.vue?vue&type=template&id=5f29bbac&scoped=true&"
import script from "./EditSubAsset.vue?vue&type=script&lang=js&"
export * from "./EditSubAsset.vue?vue&type=script&lang=js&"
import style0 from "./EditSubAsset.vue?vue&type=style&index=0&id=5f29bbac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f29bbac",
  null
  
)

export default component.exports